/** AUTO GENERATED FROM "node ./src/utils/build-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg
        width="82.98"
        height="94.4"
        viewBox="0 0 82.98 94.4"
        fill="currentColor"
        className={classNames('nmx-icon', className)}
        ref={svgRef}
        {...otherProps}>
        <path
          fill="#fff"
          d="M41.5 11.42a41.49 41.49 0 1 0 41.48 41.5 41.52 41.52 0 0 0-41.48-41.5Zm0 2.5a39 39 0 1 1-39 39 39 39 0 0 1 39-39Z"
          className="icon-fill icon-base"/>
        <path
          fill="#fff"
          d="M35.36 12.67h13.23V4.3H35.36v8.37z"
          className="icon-fill icon-base"
          fillRule="evenodd"/>
        <path
          fill="#fff"
          d="M52.43 6.81h-20.9a.5.5 0 0 1-.5-.5V.5a.51.51 0 0 1 .5-.5h20.9a.5.5 0 0 1 .5.5v5.81a.5.5 0 0 1-.5.5"
          className="icon-fill icon-base"
          fillRule="evenodd"/>
        <path
          fill="#ffb81c"
          d="M39.86 30.56v3.88l-.6.11-.58.15a9.25 9.25 0 0 0-7 5.68 11.37 11.37 0 0 0-.81 5.29 9.15 9.15 0 0 0 4.87 7.74 42.4 42.4 0 0 0 4.07 1.82c1.7.72 3.43 1.37 5.13 2.1a3.1 3.1 0 0 1 1.94 3.38 3.4 3.4 0 0 1-2.72 3.4 10.4 10.4 0 0 1-2.15.23 5.36 5.36 0 0 1-5.47-4c-.15-.48-.27-1-.42-1.49l-6.49 1.67a13.49 13.49 0 0 0 3.14 6.43 11 11 0 0 0 7.12 3.29v5h4.2v-5c.85-.17 1.67-.3 2.47-.5a9.72 9.72 0 0 0 6.83-5.55 11.29 11.29 0 0 0 .79-6.78 8.88 8.88 0 0 0-4.55-6.44 48.89 48.89 0 0 0-6.21-2.72 50.6 50.6 0 0 1-3.75-1.7 2.69 2.69 0 0 1-1.35-1.64 3.78 3.78 0 0 1 2.5-4.73h.15a4.38 4.38 0 0 1 4.35 1.13 8.11 8.11 0 0 1 1.76 2.67c.15.32.28.64.42 1l5.82-2.41a11.71 11.71 0 0 0-2.14-4.38 10.22 10.22 0 0 0-7.06-3.68v-3.88Z"
          className="icon-fill icon-accent"
          fillRule="evenodd"/>
        <path
          fill="#fff"
          d="m74.74 22.33-10.45-8.28a.52.52 0 0 1-.08-.71l2.75-3.47a.52.52 0 0 1 .71-.08l10.44 8.28a.5.5 0 0 1 .08.7l-2.75 3.47a.51.51 0 0 1-.7.09"
          className="icon-fill icon-base"
          fillRule="evenodd"/>
        <path
          fill="#fff"
          d="m68.61 23.74-4.28-3.4 4.74-5.97 4.28 3.39-4.74 5.98z"
          className="icon-fill icon-base"
          fillRule="evenodd"/>
      </svg>

    );
  }
}

Icon.displayName = 'StopwatchWithDollarSignIcon';

export default Icon;
